export default "__VITE_ASSET__Cyvf76Si__"